import { GetterTree } from 'vuex';
import { RootState } from '@/store';

import { State } from './state';

export type Getters = {
  getLoadertruckisOpened(state: State): boolean | null;
};

export const getters: GetterTree<State, RootState> & Getters = {
  getLoadertruckisOpened: (state) => state!.loading
};
